import script from "./SplashPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SplashPage.vue?vue&type=script&setup=true&lang=js"

import "./SplashPage.vue?vue&type=style&index=0&id=4eed111a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eed111a"]])

export default __exports__